#import '../../fragments/userNotification.fragment.graphql'

mutation markAsViewed($id: String!) {
  markAsViewed(input: { id: $id }) {
    notifications {
      ...UserNotificationFragment
    }
  }
}
